<template>
  <thead>
    <tr>
      <!--
        Con hide-default-header el checkbox de "seleccionar todo" hay que dibujarlo
        acá. Ojo: selecciona solo los registros visibles de la página, no todos los
        que coinciden con los filtros.
      -->
      <th v-if="showSelect" class="v-data-table__checkbox-header" width="1">
        <v-simple-checkbox
          :value="everyItem"
          :indeterminate="someItems && !everyItem"
          color="primary"
          @input="$emit('toggle-select-all', $event)"
        />
      </th>
      <template v-for="header in visibleHeaders">
        <th :key="header.value" @click="header.sortable ? $emit('sort', header.value) : null" :width="header.width">
          <v-row class="ma-0" align="center" :justify="header.align">
            <span>{{header.text}}</span>
            <template v-if="header.sortable">
              <v-icon class="sorting sort" v-if="![header.value, `-${header.value}`].includes($route.query.ordering)" small />
              <v-icon class="sorting sort-Up" v-if="$route.query.ordering === `-${header.value}`" small />
              <v-icon class="sorting sort-Down" v-if="$route.query.ordering === header.value" small />
            </template>
          </v-row>
        </th>
      </template>
    </tr>
  </thead>
</template>
<script>
export default {
  props: {
    headers: {
      type: Array,
      required: false,
      default: () => []
    },
    sortable: {
      type: Boolean,
      required: false,
      default: false
    },
    showSelect: {
      type: Boolean,
      required: false,
      default: false
    },
    everyItem: {
      type: Boolean,
      required: false,
      default: false
    },
    someItems: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    visibleHeaders () {
      /**
       * Con show-select, v-data-table hace unshift de una cabecera propia
       * { value: 'data-table-select' } dentro de props.headers. Este componente ya
       * dibuja ese th, así que hay que descartarla o la cabecera queda con una
       * celda de más y las columnas se corren respecto al cuerpo.
       */
      return this.headers.filter(
        (header) => !['data-table-select', 'data-table-expand'].includes(header.value)
      )
    }
  }
}
</script>
<style scoped>
.sorting.sort {
  background-image: url('../../assets/appIcon-ui--tableSort.svg');
}
.sorting.sort-Up {
  background-image: url('../../assets/appIcon-ui--tableSortUp.svg');
}
.sorting.sort-Down {
  background-image: url('../../assets/appIcon-ui--tableSortDown.svg');
}
</style>
